import QRScanner from "./QRScanner";
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import EmailOtp from "./EmailOtp";
import ConfirmTicket from "./ConfirmTicket";
import Confirmed from "./Confirmed";

function App() {
  return (
    <div>
      <Router basename="/">
      <Routes>
        <Route path="/" element={<QRScanner />} />
        <Route path="/email-otp/:qrcode_id" element={<EmailOtp />} />
        <Route path="/confirm-ticket/:qrcode_id" element={<ConfirmTicket />} />
        <Route path="/confirmed" element={<Confirmed />} />
      </Routes>
    </Router>
    </div>
  );
}

export default App;
